export default class GoogleMapsHelper {
    public static mapInstance: any = null;
    public static mapMarkers: any[] = [];
    public static infoWindows: any[] = [];
    public static activeInfoWindowId: any = null;

    static loader = new (<any>window).Loader({
        apiKey: (<any>document.getElementById("GoogleMapsAPIKey"))?.value,
        version: "weekly",
        libraries: ["core", "maps", "marker"]
    });

    static mapOptions = {
        center: { lat: 50.2016234, lng: 16.0572682 },
        zoom: 5,
        minZoom: 4,
        maxZoom: 10,
        mapId: "#",
        disableDefaultUI: true,
        clickableIcons: false,
        zoomControl: false,
        zoomControlOptions: {
            position: 0
        },
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    }

    static async loadMap(isZoomControlEnable: boolean = true) {
        const self = this;
        let zoomLevel = self.mapOptions.zoom;

        await this.loader.importLibrary("maps").then(async ({ Map }) => {
            await self.waitForAdvancedMarker().then(() => {
                if (isZoomControlEnable) {
                    self.mapOptions.zoomControl = true;
                    self.mapOptions.zoomControlOptions.position = google.maps.ControlPosition.TOP_RIGHT;
                }
                self.mapInstance = new Map(document.getElementById("GoogleMaps") as HTMLElement, self.mapOptions);
                self.mapInstance.setZoom(zoomLevel);
            });
        });
    }

    static async waitForAdvancedMarker(retries = 10, delay = 200): Promise<void> {
        await google.maps.importLibrary("marker");

        return new Promise((resolve, reject) => {
            const check = () => {
                if ((google.maps as any)?.marker?.AdvancedMarkerElement) {
                    resolve();
                } else if (retries <= 0) {
                    reject(new Error("AdvancedMarkerElement not available"));
                } else {
                    retries--;
                    setTimeout(check, delay);
                }
            };
            check();
        });
    }

    static getBounds() {
        return this.mapInstance.getBounds();
    }

    static setCenter(lat: number, lng: number) {
        this.mapInstance.setCenter(new google.maps.LatLng(lat, lng));
    }

    static addMarker(id: string, name: string, contents: string, lat: number, lng: number, icon: string) {
        const self = this;

        const markerInfo = document.createElement("img");
        markerInfo.src = "/images/" + icon;
        markerInfo.style.width = "25";
        markerInfo.style.height = "25";
        markerInfo.classList.add("geomarker");

        const infowindow = new google.maps.InfoWindow({
            content: contents,
            ariaLabel: name,
            disableAutoPan: true
        });

        infowindow.set("id", id);

        infowindow.addListener("closeclick", () => {
            this.activeInfoWindowId = null;
        });

        this.infoWindows.push(infowindow);

        const marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.mapInstance,
            position: { lat: lat, lng: lng },
            content: markerInfo,
            title: name,
            collisionBehavior: google.maps.CollisionBehavior.REQUIRED_AND_HIDES_OPTIONAL
        });

        marker.id = id;

        marker.addListener("gmp-click", () => {
            for (const item of this.infoWindows) {
                item.close();
            }

            this.activeInfoWindowId = id;

            infowindow.open({
                anchor: marker,
                map: self.mapInstance,
                shouldFocus: true
            });

            this.setCenter(lat, lng);
        });

        this.mapMarkers.push(marker);

        if (this.activeInfoWindowId == id) {
            infowindow.open({
                anchor: marker,
                map: self.mapInstance,
                shouldFocus: true
            });
        }
    }

    static clickMarker(markerId: string) {
        let marker = this.mapMarkers.find(x => x.id === markerId);
        if (marker) {
            let infowindow = this.infoWindows.find(x => x.id === markerId);

            for (const item of this.infoWindows) {
                this.activeInfoWindowId == null;
                item.close();
            }

            infowindow.open({
                anchor: marker,
                map: this.mapInstance,
                shouldFocus: true
            });

            this.activeInfoWindowId = markerId;
        }
    }

    static removeMarkers() {
        for (const item of this.infoWindows) {
            item.close();
        }

        this.infoWindows = [];

        for (const item of this.mapMarkers) {
            item.map = null;
        }

        this.mapMarkers = [];
    }

    static setActiveInfoWindowId(id: string) {
        if (this.activeInfoWindowId !== null) {
            for (const item of this.infoWindows) {
                item.close();
            }
        }

        this.activeInfoWindowId = id;
    }
}